window.optimizely = window.optimizely || [];

export const activate = (experimentId) => {
  if (experimentId) {
    window.optimizely.push(['activate', experimentId]);
  } else {
    window.optimizely.push(['activate']);
  }
};

export const bucketVisitor = (experimentId, variationId) => {
  window.optimizely.push(['bucketVisitor', experimentId, variationId]);
};

export default {
  activate,
  bucketVisitor,
};



/** WEBPACK FOOTER **
 ** ./modules/optimizely/index.js
 **/